import { useEffect, useState } from "react";

export const MAILBOX_OCCUPANCY_FILTERS = [
  { value: "all", label: "All" },
  { value: "occupied", label: "Occupied" },
  { value: "available", label: "Available" },
];

export default function MailboxFilterModal({ value, onApply, onClose }) {
  const [selection, setSelection] = useState(value);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div
      className="admin-modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section className="admin-modal admin-filter-modal" role="dialog" aria-modal="true" aria-labelledby="mailbox-filter-title">
        <div className="admin-modal-header">
          <div>
            <p className="admin-page-eyebrow">Mailbox list</p>
            <h2 id="mailbox-filter-title">Filter mailboxes</h2>
            <p>Choose mailboxes by their current tenant assignment.</p>
          </div>
          <button className="admin-modal-close" type="button" aria-label="Close mailbox filters" onClick={onClose}>&times;</button>
        </div>
        <div className="admin-modal-body">
          <fieldset className="admin-filter-options">
            <legend>Occupancy</legend>
            {MAILBOX_OCCUPANCY_FILTERS.map((filter) => (
              <label key={filter.value}>
                <input
                  type="radio"
                  name="mailboxOccupancyFilter"
                  value={filter.value}
                  checked={selection === filter.value}
                  onChange={(event) => setSelection(event.target.value)}
                />
                <span>{filter.label}</span>
              </label>
            ))}
          </fieldset>
        </div>
        <div className="admin-modal-footer">
          <button className="admin-button admin-button-secondary" type="button" onClick={onClose}>Cancel</button>
          <button className="admin-button admin-button-primary" type="button" onClick={() => onApply(selection)}>Apply Filter</button>
        </div>
      </section>
    </div>
  );
}
